import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestCookieUnassignedGet = {
    path: "/cookies/unassigned",
    method: RouteHttpVerb.GET
};
